module.exports = __webpack_public_path__ + "img/avatar2.97d463b5.svg";